import { SanctionMatchResolution } from '../../entities/monitoring/actual/sanction-matches.model';
import { BadPressMatchResolution } from 'app/entities/monitoring/actual/badpress-match.model';
import { PEPMatchResolution } from 'app/entities/monitoring/actual/pep-match.model';

/**
 * Model to capture a Person.
 */
export class Person {
    id: number;
    entityId: number;
    personId: string;
    firstNames: string;
    lastNames: string;
    middleNames: string;
    callingName: string;
    gender: number;
    genderName: string;
    birthday: number | string;
    nationality: number;
    nationalityName: string;
    ssn: string;
    logo: string;
    sanctionStatus = SanctionMatchResolution.FALSE;
    isPep: boolean;
    pepStatus = PEPMatchResolution.FALSE;
    badPressStatus = BadPressMatchResolution.FALSE;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/person.model.ts